import styled from "styled-components";
export const LoaderContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.loader.background};
  transition: all 0.3s ease-in-out;
`;
export const LoaderContainerDashboard = styled(LoaderContainer)`
  background-color: ${(props) => props.theme.loader.backgroundDashboard};
`;